// extracted by mini-css-extract-plugin
export default {"footerCta":"FooterCta-footerCta-3tw"};